import { VehicleContract } from './VehicleContract';

type Nullable<T> = {
    [P in keyof T]: T[P] | null;
};

type EditableKeys = Pick<
    VehicleContract,
    | 'vehicleType'
    | 'vehicleMakeId'
    | 'vehicleModel'
    | 'vehicleModelType'
    | 'vehicleRegistrationNumber'
    | 'vehicleIdentificationNumber'
    | 'vehicleFirstRegistryDate'
    | 'vehicleEnginePowerType'
    | 'vehicleElectricalClass'
    | 'vehicleCo2EmissionWltp'
    | 'vehicleSuggestedRetailPrice'
    | 'vehicleDiscount'
    | 'vehicleCarTax'
    | 'vehicleDeliveryFee'
    | 'vehicleFactoryAccessoryPriceExclCarTax'
    | 'vehicleFactoryAccessoryCarTax'
    | 'vehicleRetrofittedAccessoryPrice'
    | 'vehicleVatPercentage'
    | 'vehicleLimitedBenefit'
    | 'vehicleFullCarBenefit'
    | 'specialUseVehicleType'
    | 'takenToUseDate'
    | 'emissionClass'
>;

export const vehicleContractFillRequestEditableKeys: Record<keyof EditableKeys, boolean> = {
    vehicleType: true,
    vehicleMakeId: true,
    vehicleModel: true,
    vehicleModelType: true,
    vehicleRegistrationNumber: true,
    vehicleIdentificationNumber: true,
    vehicleFirstRegistryDate: true,
    vehicleEnginePowerType: true,
    vehicleElectricalClass: true,
    vehicleCo2EmissionWltp: true,
    vehicleSuggestedRetailPrice: true,
    vehicleDiscount: true,
    vehicleCarTax: true,
    vehicleDeliveryFee: true,
    vehicleFactoryAccessoryPriceExclCarTax: true,
    vehicleFactoryAccessoryCarTax: true,
    vehicleRetrofittedAccessoryPrice: true,
    vehicleVatPercentage: true,
    vehicleLimitedBenefit: true,
    vehicleFullCarBenefit: true,
    specialUseVehicleType: true,
    takenToUseDate: true,
    emissionClass: true,
} as const;

type VehicleContractFillRequestEditableKeys = Nullable<
    Pick<VehicleContract, keyof typeof vehicleContractFillRequestEditableKeys>
>;

export interface VehicleContractFillRequest extends VehicleContractFillRequestEditableKeys {
    readonly id: string;
    readonly vehicleContractId: string;
    readonly created: Date;
    readonly modified: Date;
    readonly emailSentDate: Date | null;
    readonly status: 'DRAFT' | 'PUBLISHED' | 'MERGED';
    readonly receiverEmail: string;
}
